import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ApexOptions } from 'ng-apexcharts';
import { ProjectService } from 'app/modules/admin/dashboards/project/project.service';
import { TransactionService } from '../services/transaction/transaction.service';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationMessage, NotificationType } from 'app/shared/notifications/NotificationMessage';
import { NotificationsService } from 'app/shared/notifications/notifications.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';

export class Filter {
  executed: boolean;
}
@Component({
  selector: 'project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectComponent implements OnInit, OnDestroy {

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  displayedColumns: string[] = ['No', 'file', 'date', 'excutedBy', 'mail', 'rapport', 'executed'];
  listData: MatTableDataSource<any> = new MatTableDataSource();

  loader: boolean = false;
  filter: Filter = new Filter();

  pageNumber: number = 1;
  totalPages: number = 0;
  search: string = "";

  listTransation: any[] = [];
  total: any;
  nb_executed: any = "";
  nb_not_executed: any = "";
  total_count: any = "";
  inputValue: string = '';
  constructor(
    private apitransactionService: TransactionService,
    private _router: Router,
    private notificationsService: NotificationsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    this.getListTransaction();
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }


  getListTransaction() {
    this.listData.data = [];
    this.listTransation = [];
    this.search = "";
    this.inputValue = "";
    this.listFile(this.search)
  }

  filterWithExecuted(executed: boolean) {
    ;
    this.pageNumber = 1;
    this.search = "";
    this.inputValue = "";
    this.listTransation = [];
    this.listData.data = [];
    this.filter.executed = executed;
    this.listFile(this.search, this.filter)

  }

  listFile(search, filter?) {
    this.startLoading()
    this.apitransactionService.getList(this.pageNumber, 15, search, filter).subscribe(
      (response) => {
        this.listTransation = response.transactions;
        this.calculateNbPages(response.total_count);
        this.listData.data = response.transactions;
        this.total = response.total;
        this.total_count = response.total_count;
        this.nb_executed = response.nb_executed;
        this.nb_not_executed = response.nb_not_executed;
        this.stopLoading();
        this._changeDetectorRef.detectChanges();
      }, (error) => {
        this.listTransation = [];
        this.listData.data = [];
        this.stopLoading()
      });
  }
  applyFilter(event: Event) {
    this.pageNumber = 1;
    this.search = (event.target as HTMLInputElement).value;
    if (this.search.length >= 3 || this.search.length === 0) {
      this.listFile(this.search);
    }

  }

  onUploadAffaires(file) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    this.apitransactionService.UploadFile(formData).subscribe(
      (response: any) => {
        this.getListTransaction();
        this.notification(NotificationType.success, 'Opération réussite', 'Vos fichiers ont été téléchargés avec succès')
      },
      (error) => {

        this.notification(NotificationType.error, 'Opération echoué', error.error.message)

      }
    );

  }

  getFiles(event) {
    let file = event.target.files[0];
    this.onUploadAffaires(file)

  }

  notification(type, title, message) {
    const notificationMessage = new NotificationMessage();
    notificationMessage.type = type;
    notificationMessage.title = title;
    notificationMessage.message = message;
    this.notificationsService.sendMessage(notificationMessage);
  }


  getFile(name, entity) {
    this.apitransactionService.getFile(name, entity).subscribe(
      (response: any) => {
        if (entity == 'f') {
          this.openBase64File(response.message, 'application/xml');

        } else {
          this.openBase64File(response.message, 'application/pdf');

        }
      }

    );

  }




  calculateNbPages(iTotalDisplayRecords: number): void {
    this.totalPages = Math.floor(iTotalDisplayRecords / 15);
    if (iTotalDisplayRecords % 15 !== 0) {
      this.totalPages += 1;
    }
  }



  first(): void {
    this.setPage(1);
  }

  prev(): void {
    this.setPage(Math.max(1, this.pageNumber - 1));
  }

  next(): void {
    this.setPage(Math.min(this.totalPages, this.pageNumber + 1));
  }

  last(): void {
    this.setPage(this.totalPages);
  }

  setPage(val: number): void {
    this.pageNumber = val;
    this.ngOnInit();
  }

  isFirst(): boolean {
    return this.pageNumber === 1;
  }

  isLast(): boolean {
    return this.pageNumber === this.totalPages;
  }

  changepage(num: number): void {
    this.pageNumber = num;
    this.ngOnInit();
  }





  private startLoading(): void {
    this.loader = true;
  }

  private stopLoading(): void {
    this.loader = false;
  }

  openBase64File(base64String: string, fileType: string) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const blobUrl = URL.createObjectURL(blob);

    const newTab = window.open(blobUrl, '_blank');
    URL.revokeObjectURL(blobUrl);
  }

}
